
import React, { useState } from "react";
import { Control } from "react-hook-form";
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

interface PasswordFieldProps {
  control: Control<any>;
  forgotPasswordLink: () => void;
}

const PasswordField: React.FC<PasswordFieldProps> = ({ control, forgotPasswordLink }) => {
  const [showPassword, setShowPassword] = useState(false);
  
  return (
    <FormField
      control={control}
      name="password"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              <label htmlFor="password" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                Password
              </label>
            </div>
            <button
              type="button"
              onClick={forgotPasswordLink} 
              className="text-sm text-grandpal-green hover:underline"
            >
              Forgot password?
            </button>
          </div>
          <FormControl>
            <div className="relative">
              <Input 
                id="password"
                type={showPassword ? "text" : "password"} 
                placeholder="Enter your password"
                autoComplete="current-password" 
                className="h-11 pr-10"
                {...field} 
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PasswordField;
